import { render, staticRenderFns } from "./Csqa.vue?vue&type=template&id=5c2eecf2&scoped=true"
import script from "./Csqa.vue?vue&type=script&lang=js"
export * from "./Csqa.vue?vue&type=script&lang=js"
import style0 from "./Csqa.vue?vue&type=style&index=0&id=5c2eecf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2eecf2",
  null
  
)

export default component.exports